/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { GetPlanPricesV1200ResponseFromJSON, } from '../models/index';
/**
 *
 */
export class PriceApi extends runtime.BaseAPI {
    /**
     * Get Updated Website Plan Prices
     * Get Updated Plan Prices
     */
    async getPlanPricesV1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/plan_prices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlanPricesV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Get Updated Website Plan Prices
     * Get Updated Plan Prices
     */
    async getPlanPricesV1(initOverrides) {
        const response = await this.getPlanPricesV1Raw(initOverrides);
        return await response.value();
    }
}
